import { render } from "./DetailFieldSocialAccount.vue?vue&type=template&id=6b464b4c&scoped=true&ts=true"
import script from "./DetailFieldSocialAccount.vue?vue&type=script&lang=ts"
export * from "./DetailFieldSocialAccount.vue?vue&type=script&lang=ts"

import "./DetailFieldSocialAccount.vue?vue&type=style&index=0&id=6b464b4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b464b4c"]])

export default __exports__